import { AxiosConfigAdmin } from "Admin/Config/AxiosConfig";
import { refreshToken } from "./Auth";
export const getUnitSummary = (entity_id, entity_type, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/unit/summary?entity_id=${entity_id}&entity_type=${entity_type}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getUnitSummary(entity_id, entity_type, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const updateUnitSummary = (
  entity_id,
  entity_type,
  payload,
  callback
) => {
  const axios = AxiosConfigAdmin();
  let url = `/unit/summary?entity_id=${entity_id}&entity_type=${entity_type}`;

  axios
    .put(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() =>
          updateUnitSummary(entity_id, entity_type, payload, callback)
        );
      } else {
        callback(err.response.data);
      }
    });
};
export const getUnitSubUnits = (entity_id, entity_type, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/unit/sub-units?entity_id=${entity_id}&entity_type=${entity_type}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getUnitSubUnits(entity_id, entity_type, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const getUnitPublications = (
  entity_id,
  entity_type,
  page,
  rowsPerPage,
  callback
) => {
  const axios = AxiosConfigAdmin();
  let url = `/unit/publications?entity_id=${entity_id}&entity_type=${entity_type}&page=${page}&rows_per_page=${rowsPerPage}&order_by=publication_year&order=desc`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() =>
          getUnitPublications(
            entity_id,
            entity_type,
            page,
            rowsPerPage,
            callback
          )
        );
      } else {
        callback(err.response.data);
      }
    });
};
export const getUnitGrants = (
  entity_id,
  entity_type,
  page,
  rowsPerPage,
  callback
) => {
  const axios = AxiosConfigAdmin();
  let url = `/unit/grants?entity_id=${entity_id}&entity_type=${entity_type}&page=${page}&rows_per_page=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() =>
          getUnitGrants(entity_id, entity_type, page, rowsPerPage, callback)
        );
      } else {
        callback(err.response.data);
      }
    });
};
export const getUnitFaculties = (
  entity_id,
  entity_type,
  page,
  rowsPerPage,
  callback
) => {
  const axios = AxiosConfigAdmin();
  let url = `/unit/facultyMembers?entity_id=${entity_id}&entity_type=${entity_type}&page=${page}&rows_per_page=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() =>
          getUnitFaculties(entity_id, entity_type, page, rowsPerPage, callback)
        );
      } else {
        callback(err.response.data);
      }
    });
};
